<div class="table-card">
  <div *ngIf="isGestionComptesAnnonceur" class="card" id="card-add">
    <div class="card-add" (click)="createList()">
      <div class="cercle-dashed">
        <mat-icon class="add-icon">add</mat-icon>
      </div>
      <h2>{{ preferenceMessages.tab_6_label_2 | translate }}</h2>
    </div>
  </div>
  <div *ngFor="let item of sortAcheteur" class="card">
    <div class="etiquette-group">
      <h2 class="text-etiquette">{{item.titre}}</h2>
      <mat-icon *ngIf="isGestionComptesAnnonceur" class="icon-etiquette icon" (click)="update(item)">create</mat-icon>
      <mat-icon *ngIf="isGestionComptesAnnonceur" class="icon-etiquette icon" (click)="delete(item)">delete_outline</mat-icon>
      <app-partage-preference [id]="item.id" class="icon-etiquette"></app-partage-preference>
    </div>
    <div class="contents">
      <div class="content">
        <span class="ml-1"><span class="font-weight-bold">{{ preferenceMessages.tab_6_label_5 | translate }}
            :&nbsp;</span>
          {{shiftBoolean(item.personnePhysique)}}</span>
      </div>
      <div class="content">
        <span class="ml-1"><span class="font-weight-bold">{{ preferenceMessages.tab_6_label_num_enregistrement |
            translate }} :&nbsp;</span>
          {{item.numEnregistrement}}</span>
      </div>
      <div class="content">
        <span class="ml-1"><span class="font-weight-bold">{{ preferenceMessages.tab_6_label_nom_officiel |
            translate }} :&nbsp;</span>
          {{item.nomOfficiel}}</span>
      </div>
      <div class="content">
        <span class="ml-1"><span class="font-weight-bold">{{ preferenceMessages.tab_6_label_departement |
            translate }} :&nbsp;</span>
          {{item.departement}}</span>
      </div>

    </div>
  </div>
</div>